import React from "react";
import { Form, Input, Button, Typography, message } from "antd";
import { NavLink } from "react-router-dom";
import LogoPng from "../../assets/logo.png";
import useLoginForm from "../../hooks/useLoginForm";

const { Title, Text } = Typography;

export default function Login() {
  const { handleLogin, contextHolder } = useLoginForm();
  const [form] = Form.useForm();

  return (
    <section className="login-bg py-8 h-screen overflow-auto w-full  shadow-lg">
      {contextHolder}
      <div className="bg-overlay-gradient"></div>
      <div className="relative z-10 flex flex-col gap-3 justify-center items-center h-full">

      <img src={LogoPng} className="w-52 mx-auto" alt="Logo" />
      <Form
        form={form}
        layout="vertical"
        className="w-full md:w-[577px] bg-white px-5 py-5 rounded-xl flex flex-col gap-4"
        onFinish={handleLogin}
        initialValues={{
          email: "",
          password: "",
        }}
      >
        <Title level={3}>Login</Title>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Email is required" },
            { type: "email", message: "Please enter a valid email address" },
          ]}
        >
          <Input placeholder="Enter your Email" size="large" />
        </Form.Item>


        <Form.Item
          name="password"
          label="Password"
          rules={[
            { required: true, message: "Password is required" },
            { min: 6, message: "Password must be at least 6 characters" },
          ]}
        >
          <Input.Password placeholder="Enter your password" size="large" />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          className="rounded-lg"
          size="large"
        >
          Log In
        </Button>
      </Form>

      <Text className="text-sm text-white text-center w-full">
        No Account?{" "}
        <NavLink to="/signup" className="!underline text-blue-600">
          Sign Up
        </NavLink>
      </Text>
      </div>

    </section>
  );
}
